export const dataSetTipoPessoa = [
  {
    nome: "Física",
    value:"pf",
    marcado: false,
    fixo: false,
  },
  {
    nome: "Jurídica",
    value:"pj",
    marcado: false,
    fixo: false,
  },
];
